<template>
	<table-paginator
		:data="commissions"
		@pagechange="$emit('pagechange', $event)"
	>
		<hr class="mb-0" />
		<template v-for="row in commissions.data">
			<b-row align-v="center" class="grid-table-row mx-0 px-0" :key="row.id">
				<div class=" order-1  col-12 col-4 col-md-4  align-center ">
					<i class="fas fa-user-tie mr-2" />
					<span style="margin-left: 10px">{{ row.name }}</span>
				</div>
				<div class="order-2  col-7 col-md-4  align-left text-center  ">
					<span style="margin-left: 24px">
						{{ row.issued_at | dateTimeBr }}</span
					>
				</div>
				<div class="order-3  col-4 col-md-3   align-right text-center ">
					<b>{{ row.comission_value | moneyBr }}</b>
				</div>
			</b-row>
		</template>
	</table-paginator>
</template>

<script>
	import TablePaginator from "./../sections/TablePaginator.vue";

	export default {
		components: {
			TablePaginator,
		},

		props: {
			commissions: {},
		},

		methods: {}
	}
</script>

<style>

</style>
